/**
 * Pre-compiled en messages for ScopedSearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { searchLabel: `Search`, selectLabel: `Filter by` };
